import { createFileRoute } from '@tanstack/react-router'
import { LegalPage } from '#/components/legal/legal-page'
import { m } from '#/paraglide/messages'

export const Route = createFileRoute('/terms')({ component: Page, head: () => ({ meta: [{ title: `${m.terms_title()} · ${m.app_name()}` }] }) })

function Page() {
  const sections = [
    { h: m.terms_1_h(), p: m.terms_1_p() },
    { h: m.terms_2_h(), p: m.terms_2_p() },
    { h: m.terms_3_h(), p: m.terms_3_p() },
    { h: m.terms_4_h(), p: m.terms_4_p() },
    { h: m.terms_5_h(), p: m.terms_5_p() },
    { h: m.terms_6_h(), p: m.terms_6_p() },
    { h: m.terms_7_h(), p: m.terms_7_p() },
    { h: m.terms_8_h(), p: m.terms_8_p() },
    { h: m.terms_9_h(), p: m.terms_9_p() },
    // Orkestrator E3 §4: the vendor rules Bystep follows (dated, sourced)
    { h: m.pol_page_title(), p: m.pol_terms_note(), link: { to: '/kebijakan-penyedia' as const, label: m.pol_link_more() } },
  ]
  return <LegalPage title={m.terms_title()} intro={m.terms_intro()} sections={sections} otherHref="/privacy" otherLabel={m.legal_see_privacy()} />
}
